// TODO: refactor this out, we should just not name groups the same and merge them before sending to checkout + handle their validation
import type { FormKitNode } from '@formkit/core'
import { undefine } from '@formkit/utils'
export function combineGroupPlugin (node: FormKitNode) {
    if (node.type !== 'group') {
        return
    }
    node.addProps([ 'combine' ])
    node.props.combine = undefine(node.props.combine)
    if (!node.props.combine) {
        return
    }
    const sameNameSibling = node.at(node.name)
    if (!sameNameSibling) {
        return
    }
    // check if it has another group with the same name as sibling.
    node.on('child', ({ payload }) => {
        payload.parent = sameNameSibling
    })
}
